<template>
  <v-form v-model="valid" ref="form">
    <div class="form-container px-10">
      <div class="form-group mb-12 text-center">
        <h1>{{title}}</h1>
        <h3 class="form-type">Login</h3>
      </div>
      <div class="form-group">
        <v-text-field
          outlined
          v-model="email"
          dense
          label="Username, email or phone number"
          placeholder=" "
          :rules="[rules.required]"/>
      </div>
      <div class="form-group frgt-pass-container">
        <v-text-field
          v-model="password"
          outlined
          dense
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required]"
          :type="showPassword ? 'text' : 'password'"
          label="Password"
          placeholder=" "
          @keydown="passwordOnKeyDown"
          @click:append="showPassword = !showPassword"/>
          <div class="frgt-pass">
            <a @click="AuthNavigateTo('gotoFpass')">Forgot password?</a>
          </div>
      </div>
      <div class="form-group my-2">
        <v-btn block color="primary" :loading="btnLoading" v-on:click="loginButtonOnClick">Login</v-btn >
      </div>
      <div class="form-group text-center">
        <span>Not Registered?<a style="margin-left: 5px" @click="AuthNavigateTo('gotoRegister')">register now</a></span>
      </div>
    </div>
  </v-form>
</template>

<script>
import LoginStrings from "./../views/Profile/LoginStrings"
import AuthPagesMixin from "../mixins/AuthPagesMixin"
export default {
  name: 'LoginForm',
  mixins: [AuthPagesMixin],
  data() {
    return {
      showAlert: false,
      email: "",
      btnLoading: false,
      password: "",
      valid: true,
      showPassword: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
    }
  },
  computed: {
    title() {
      return window.location.hostname.split(".").splice(1).join(".")
    }
  },
  methods: {
    passwordOnKeyDown: function (e) {
      if (e.keyCode == 13) {
        e.preventDefault()
        this.loginButtonOnClick()
      }
    },
    alert: function (response) {
      var msg = 'Unknown User!'
      if (response && response.status == 422) {
        msg = LoginStrings(this, 'wrong_entries')
      } else if (response && response.status > 400) {
        msg = LoginStrings(this, "something_went_wrong")
      }
      this.ShowInfo('error', msg)
    },
    loginButtonOnClick() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.btnLoading=true
      this.axios
        .post(`/login${window.location.search}`, {
          login: this.email,
          password: this.password,
        })
        .then(response => {
          if (!this.global.passwordRegex.test(this.password)) {
            this.$store.commit('setPasswordUpdate', true)
          }
          if (response.status == 204) {
            this.AuthNavigateTo('loginVerify')
          } else {
            if (response.data && response.data.redirecturl && response.data.redirecturl != "/") {
              window.location.href = response.data.redirecturl
            } else {
              this.close()
            }
          }
        })
        .catch((ctx) => {
          this.alert(ctx.response)
        }).finally(()=>{
          this.btnLoading=false
        })
    },
    reset() {
      this.$refs.form.reset()
    },
  },
}
</script>

<style>
.frgt-pass-container{
  position: relative;
}
.frgt-pass a{
  position: absolute;
  bottom: 5px;
  right: 0;
  font-size: 12px;
  color: grey !important;
}
.frgt-pass a:hover{
  color: #e65081 !important;
}
.form-type{
  color: grey;
}
</style>